import { useEffect, useState } from 'react';

/**
 * Whole seconds left before `notBefore` (epoch ms), ticking once a second;
 * 0 when there is no wait or it has passed. The Retry pill shows it and stays
 * disabled meanwhile: a 429 answered again inside its window is a wasted
 * request and the same message back (2026-10-13).
 */
export function useRetryCountdown(notBefore: number | null | undefined): number {
  const [seconds, setSeconds] = useState(() => secondsLeft(notBefore));
  useEffect(() => {
    setSeconds(secondsLeft(notBefore));
    if (!notBefore || notBefore <= Date.now()) return;
    const timer = setInterval(() => {
      const left = secondsLeft(notBefore);
      setSeconds(left);
      if (left === 0) clearInterval(timer);
    }, 1000);
    return () => clearInterval(timer);
  }, [notBefore]);
  return seconds;
}

export function secondsLeft(notBefore: number | null | undefined, now: number = Date.now()): number {
  if (!notBefore) return 0;
  return Math.max(0, Math.ceil((notBefore - now) / 1000));
}

/** "Retry" while free, "Retry (42s)" while the limiter's window runs. */
export function retryLabel(retry: string, seconds: number): string {
  return seconds > 0 ? `${retry} (${seconds}s)` : retry;
}
